import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useIsFeatureEnabled } from "../_app/featureFlags";
import { Users } from "../users/Users";

export const Route = createFileRoute("/nutzer")({
  loader: async ({ context: { queryClient, trpc } }) => {
    void queryClient.ensureQueryData(trpc.users.list.queryOptions());
  },
  component: UsersRoute,
});

function UsersRoute() {
  const isManageServiceUsersEnabled = useIsFeatureEnabled("manageServiceUsers");

  if (!isManageServiceUsersEnabled) {
    return <Navigate to="/" />;
  }

  return <Users />;
}
